import { render, staticRenderFns } from "./AppTemplateContent.vue?vue&type=template&id=18b45d92&scoped=true"
import script from "./AppTemplateContent.vue?vue&type=script&lang=js"
export * from "./AppTemplateContent.vue?vue&type=script&lang=js"
import style0 from "./AppTemplateContent.vue?vue&type=style&index=0&id=18b45d92&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b45d92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18b45d92')) {
      api.createRecord('18b45d92', component.options)
    } else {
      api.reload('18b45d92', component.options)
    }
    module.hot.accept("./AppTemplateContent.vue?vue&type=template&id=18b45d92&scoped=true", function () {
      api.rerender('18b45d92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/appTemplate/AppTemplateContent.vue"
export default component.exports